// GAVION ai-email: one AiApi for the app (mounted by GavionLayout): the fake in the demo, Supabase otherwise.
import { useDataProvider, useGetIdentity, usePermissions } from "ra-core";
import { useMemo, type ReactNode } from "react";
import { dataProviderStore } from "../dialer/api/recordStore";
import { listTimeline } from "../demo/fakerestLeads";
import { IS_DEMO } from "../env";
import { safeSupabaseClient } from "../integrations/M365ApiRoot";
import type { TimelineRow } from "../../../../supabase/functions/_shared/ai/types.ts";
import { AiApiProvider } from "./api/AiApiContext";
import { createFakeAiApi } from "./api/fakeAiApi";
import { createSupabaseAiApi } from "./api/supabaseAiApi";
import { unavailableAiApi } from "./api/unavailableAiApi";

export const AiApiRoot = ({
  children,
  isDemo = IS_DEMO,
}: {
  children: ReactNode;
  isDemo?: boolean;
}) => {
  const dataProvider = useDataProvider();
  const { identity } = useGetIdentity();
  const { permissions } = usePermissions();
  const me = identity?.id;
  const signedIn = me !== undefined && me !== null;
  const api = useMemo(() => {
    if (!signedIn) return unavailableAiApi();
    if (!isDemo) {
      const c = safeSupabaseClient();
      return c ? createSupabaseAiApi(c) : unavailableAiApi();
    }
    return createFakeAiApi({
      store: dataProviderStore(dataProvider),
      me: Number(me),
      isAdmin: permissions === "admin",
      // the same 61-row window as the Supabase port (the 61st marks the cut)
      timeline: async (companyId) =>
        (
          await listTimeline(dataProvider, {
            filter: { company_id: companyId },
            pagination: { page: 1, perPage: 61 },
            sort: { field: "at", order: "DESC" },
          })
        ).data as unknown as TimelineRow[],
    });
  }, [dataProvider, me, signedIn, isDemo, permissions]);
  return <AiApiProvider api={api}>{children}</AiApiProvider>;
};
